import React from "react";
import Lottie from "lottie-react";
import "./WelcomeModal.css";
import seal from "../assets/seal.png";
import runningCatAnimation from "../assets/lottie/running-cat.json";

const WelcomeModal = ({ isOpen, isAdmin, onClose }) => {
  if (!isOpen) return null;

  const pageItems = [
    {
      title: "Calendar",
      description:
        "See day-by-day instruction, milestones, and lesson links in one timeline.",
    },
    {
      title: "Guide",
      description:
        "Read unit guide context, vocabulary, clarifications, and lesson sequence in one place.",
    },
    {
      title: "Units",
      description:
        "Review scope windows, TEKS coverage, and pacing health by unit.",
    },
    {
      title: "Planner",
      description:
        "Build your week with teacher notes, resources, and personal planning details.",
    },
    {
      title: "TEKS",
      description:
        "Browse standards with connected lessons and instructional context.",
    },
    {
      title: "Tasks",
      description:
        "Open and manage performance tasks tied to your curriculum flow.",
    },
    {
      title: "Kiosk Control",
      description:
        "Publish classroom-ready daily objectives from the same planning data.",
    },
  ];

  if (isAdmin) {
    pageItems.push({
      title: "Admin",
      description:
        "Manage curriculum data, scope windows, guides, and system-level updates.",
    });
  }

  return (
    <div
      className="welcome-modal-overlay"
      role="dialog"
      aria-modal="true"
      aria-label="Welcome overview"
    >
      <div className="welcome-modal-card">
        <div className="welcome-modal-header">
          <h3>Welcome to the Instructional Planner</h3>
          <button
            type="button"
            className="welcome-modal-close-btn"
            onClick={onClose}
          >
            Close
          </button>
        </div>

        <div className="welcome-modal-body">
          <div className="welcome-intro">
            <img
              src={seal}
              alt="Instructional Planner Seal"
              className="welcome-seal"
            />
            <p>
              This site turns static curriculum files into one connected workspace
              for daily teaching decisions.
            </p>
          </div>

          <div className="welcome-highlight">
            <div className="welcome-highlight-content">
              <div className="welcome-highlight-copy">
                <h4>Why this is better than a pile of PDFs</h4>
                <ul>
                  <li>Everything is connected: TEKS, units, lessons, and calendar.</li>
                  <li>You can move from high-level pacing to daily lesson detail in one click.</li>
                  <li>Teacher planning notes and resources live with the instructional day.</li>
                </ul>
              </div>
              <div className="welcome-highlight-lottie" aria-hidden="true">
                <Lottie
                  animationData={runningCatAnimation}
                  loop
                  autoplay
                  className="welcome-lottie"
                />
              </div>
            </div>
          </div>

          <div className="welcome-pages">
            <h4>What each page is for</h4>
            <div className="welcome-page-grid">
              {pageItems.map((item) => (
                <article key={item.title} className="welcome-page-card">
                  <h5>{item.title}</h5>
                  <p>{item.description}</p>
                </article>
              ))}
            </div>
          </div>
        </div>

        <div className="welcome-modal-actions">
          <button type="button" className="primary-btn" onClick={onClose}>
            Got It
          </button>
        </div>
      </div>
    </div>
  );
};

export default WelcomeModal;
